import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { actions as formActions } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";
import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { useKonfiguracniParametry } from "b2b/api/hooks";
import { ADMIN } from "b2b/api/paths";

import useMessages from "../i18n/useMessages";

export const FORM_MODULE_KEY = "konfiguracniParametryEditaceForm";

export default function useKonfiguracniParamteryEditaceWidget() {
  const { saveDialogTitle } = useMessages();
  const loader = useKonfiguracniParametry();
  const dispatch = useDispatch();
  const { showDialog, hideDialog } = useDialogsProvider();

  const handleSuccess = useCallback(() => {
    hideDialog();
    loader.reload();
  }, [hideDialog, loader.reload]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: ADMIN.konfigParametry(values.id),
        method: "put",
        payload: values.konfiguracniParametry,
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [showDialog, handleSuccess]
  );

  useEffect(() => {
    dispatchModuleAction(
      dispatch,
      FORM_MODULE_KEY,
      formActions.setValues({ konfiguracniParametry: loader.data })
    );
  }, [loader.data]);

  return {
    ...loader,
    formModuleKey: FORM_MODULE_KEY,
    handleSubmit
  };
}
